/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  UpdateEncounterStatusErrorResponse,
  UpdateEncounterStatusRequest,
  UpdateEncounterStatusResponse,
} from './api.schemas';

import { api } from '../util/http';

export const updateEncountersStatus = (
  encounterId: number,
  updateEncounterStatusRequest: UpdateEncounterStatusRequest,
) => {
  return api<UpdateEncounterStatusResponse>({
    url: `/api/encounters/${encounterId}/status`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateEncounterStatusRequest,
  });
};

export const getUpdateEncountersStatusMutationOptions = <
  TError = UpdateEncounterStatusErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEncountersStatus>>,
    TError,
    { encounterId: number; data: UpdateEncounterStatusRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEncountersStatus>>,
  TError,
  { encounterId: number; data: UpdateEncounterStatusRequest },
  TContext
> => {
  const mutationKey = ['updateEncountersStatus'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEncountersStatus>>,
    { encounterId: number; data: UpdateEncounterStatusRequest }
  > = (props) => {
    const { encounterId, data } = props ?? {};

    return updateEncountersStatus(encounterId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEncountersStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEncountersStatus>>
>;
export type UpdateEncountersStatusMutationBody = UpdateEncounterStatusRequest;
export type UpdateEncountersStatusMutationError = UpdateEncounterStatusErrorResponse;

export const useUpdateEncountersStatus = <
  TError = UpdateEncounterStatusErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEncountersStatus>>,
      TError,
      { encounterId: number; data: UpdateEncounterStatusRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEncountersStatus>>,
  TError,
  { encounterId: number; data: UpdateEncounterStatusRequest },
  TContext
> => {
  const mutationOptions = getUpdateEncountersStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
